import './App.css';
import {Routes, Route, Navigate} from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import Home from './pages/Home'
import Login from './pages/Login';
import Signup from './pages/Signup';
import Chatbot from './pages/DnDChat';

  const ProtectedRoute = ({ children }) => {
    const {currentUser, loading} = useAuth();
    if (loading) {
      return <div>Loading...</div>
    }
    if (!currentUser) {
      return <Navigate to="/" />
    }
    return children;
};

const PublicOnlyRoute = ({children}) => {
  const {currentUser, loading} = useAuth();
  if (loading) {
    return <div>Loading...</div>
  } 
  if (currentUser) {
    return <Navigate to="/dndchat" />
  }
  return children;
}

function App() {

  return (
    <Routes>
      <Route path = "/" element = {<PublicOnlyRoute><Home /></PublicOnlyRoute>} />
      <Route path = "/login" element={<PublicOnlyRoute><Login /></PublicOnlyRoute>} />
      <Route path = "/signup" element={<PublicOnlyRoute><Signup /></PublicOnlyRoute>} />
      <Route path = "/DnDChat" element = {<ProtectedRoute><Chatbot /></ProtectedRoute>}/>
      <Route path = "*" element={<Navigate to="/" />} />
    </Routes>
  );
}

export default App;
